<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card>
      <v-card-text>
        <v-row justify="center">
          <v-col sm="3">
            <h3>Calendar</h3>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-combobox
              dense
              required
              v-model="academicyear"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
              persistent-hint
              hint="Please Select Academic Year"
            />
          </v-col>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-combobox
              dense
              required
              v-model="stream"
              :items="stream_list"
              item-text="name"
              label="Stream"
              @change="get_divisions_stream(stream)"
              outlined
              persistent-hint
              hint="Please Select Stream"
            />
          </v-col>
          <!-- <v-col sm="2" v-if="standard_list.length > 0">
            <v-icon color="error">*</v-icon>
            <v-combobox
              dense
              required
              v-model="standard"
              :items="standard_list"
              item-text="name"
              item-value="id"
              label="Standard"
              outlined
            />
          </v-col> -->
          <v-col sm="2" v-if="division_list.length > 0">
            <v-icon color="error">*</v-icon>
            <v-combobox
              dense
              required
              v-model="division"
              :items="division_list"
              item-text="divname"
              label="Division"
              outlined
              persistent-hint
              hint="Please Select Division"
              multiple
            />
          </v-col>
        </v-row>
        <br>
       

        <v-row>
          <v-col cols="6">
            <v-radio-group v-model="event_type" row>
              <v-radio
                v-for="event in event_type_list"
                :key="event"
                :label="event"
                :value="event"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6">
            <input
              class="mt-7 pt-0"
              id="datePickerId"
              type="date"
              v-model="datetime"
              
              
            />
            <!-- <v-datetime-picker dateFormat="dd-MM-yyyy" label="Select Datetime" v-model="datetime"></v-datetime-picker> -->
          </v-col>
        </v-row>
        <v-col cols="12">
          <v-text-field
            label="Title"
            v-model="title"
            placeholder="Colleges reopens"
          >
            <template v-slot:prepend>
              <v-icon color="red" size="15px"> mdi-asterisk </v-icon>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
            label="Description"
            v-model="description"
            value
            placeholder="Colleges reopens on...."
            hint="Enter description of notice or home work"
          ></v-textarea>
        </v-col>

        <v-btn
          @click="putCalendar"
          :loading="send_btn_load"
          v-if="stream && division && event_type && datetime &&title"
          color="info"
        >
          Send</v-btn
        >
      </v-card-text>
    </v-card>
    <br />
     <v-row justify="center">
              <v-col cols="12" sm="2">
                <!-- <p><v-icon color="error">*</v-icon><b>From Date</b></p> -->
                <v-text-field outlined dense type="date" v-model="fromdate" label="From Date" hint="From Date"></v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
                    <!-- <p><v-icon color="error">*</v-icon><b>To Date</b></p> -->
                    <v-text-field outlined dense type="date" v-model="todate" label="To Date" hint="To Date"></v-text-field>
            </v-col>
              <v-col cols="12" sm="2">
                <!-- <p><br></p> -->
                <v-btn @click="fetchNotices()" :loading="send_btn_load" color="info">Fetch Events</v-btn>
              </v-col>
        </v-row>
        <br>
     <v-row dense justify="center" v-if="calendar_list!=''">
                            <v-radio-group inline v-model="view" row>
                                <v-radio label="Single" value="Single"></v-radio>
                                <v-radio label="Cummalative" value="Cummalative"></v-radio>
                            </v-radio-group>
                        </v-row>

          <template v-if="view == 'Single'">
                <div>
        <v-data-table
          :items="calendar_list"
          :headers="headers"
          class="elevation-1"
          :search="search"
        >
          <template v-slot:top>
           <v-toolbar flat class="toolbar" color="white" align="center" justify="center">
              <v-toolbar-title>List of Calendar Events</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <div>
              <v-btn
                color="secondary"
                icon
                dark
                @click="editDialog(item)"
                title="Edit Calendar Event"
              >
                <!-- v-on="on" -->

                <!-- <v-icon left>mdi-email-send-outline</v-icon> -->
                <v-icon>mdi-file-document-edit</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.delete`]="{ item }">
            <div>
              <v-btn
                color="warning"
                icon
                dark
               
                @click="deleteCalendarEvent(item)"
                title="Delete Calendar Event"
                :loading="delete_attach_load"
              >
               <!-- v-on="on"/ -->
                <!-- <v-icon left>mdi-email-send-outline</v-icon> -->
                <v-icon>mdi-delete-empty</v-icon>
              </v-btn>
            </div>
          </template>
            <template v-slot:[`item.read_by_parent`]="{ item }">
            <div>
               <v-icon medium class="mr-2" @click="getStatus(item.id)"> mdi-eye-outline</v-icon>
            </div>
          </template>
        </v-data-table>
      </div>
            </template>

        <template v-if="view == 'Cummalative'">
                <v-row dense>
                    <!-- {{ cum_list }} -->
                    <v-col cols="12" sm="12" md="12" v-for="(value, key) in cum_list" :key="key">
                        <v-card class="box box1" fill-height>
                          <v-btn class="link" :loading="delete_loader" style="float:right" @click="deleteCommnByMsgId(key)" color="red"> <v-icon >mdi-trash-can</v-icon></v-btn>
                            <span v-for="(std, ind) in value" :key="ind">
                                <h3 v-if="ind == 0">Title : {{ value[0] }}</h3>
                                <div v-else-if="ind == 1">
                                   <b> Description:</b>{{ value[1]}} <br />
                                    <span> {{ std }} </span><br />
                                </div>
                                <v-btn color="info" small style="margin: 2px;" v-else>
                                    {{ std }}
                                </v-btn>
                            </span>
                        </v-card>
                    </v-col>
                </v-row>
        </template>         

<v-dialog v-model="status_dialog" max-width="1200px">
 <v-card>
      <v-card-text>
        <v-data-table :headers="status_headers" :items="comm_read_status" :search="search">
          <template v-slot:top>
            <v-toolbar flat color="white" align="center" justify="center">
              <v-toolbar-title>List of Receipients</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
                <strong>Total Receipients- </strong>{{total_receipients}}
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card-text>
        <v-card-actions class="justify-center"><v-btn class="dialog-btn" @click="status_dialog = false">Close</v-btn></v-card-actions>
    </v-card>
 </v-dialog>




    <div>
     
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    from_date: null,send_btn_load:false,
    to_date: null,
    view: null,
    delete_attach_load:false,
    ay_list: [],
    academicyear: "",
    stream: "",
    stream_list: [],
    event_type_list: [],
    division_list: [],
    standard_list: [],
    division: [],
    standard: "",
    event_type: "",
    datetime: null,
    datetime: false,
    search: "",
    snackbar_msg: "",
    snackbar: false,
    color: "",
    calendar_list: "",
    awspath: null,
    title: null,description:"",
    comm_read_status:[],status_dialog:false,total_receipients:"",
    status_headers: [
      { text: "Sr No", value: "srno", sortable: true },
      { text: "Read By", value: "learner", sortable: true },
       { text: "Read Date", value: "read_date", sortable: true },
    ],
    headers: [
      { text: "Date", value: "date", sortable: true },
      { text: "From", value: "from", sortable: true },
      { text: "To", value: "to", sortable: true },
      { text: "Title", value: "title", sortable: true },
      { text: "Description", value: "description", sortable: true },
       { text: "View Status", value: "read_by_parent", sortable: true },
      // { text: "Edit", value: "edit", sortable: false },
      { text: "Delete", value: "delete", sortable: false },
    ],
    cum_list: [],basepath:null,delete_loader:false,
    fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
    todate: new Date().toISOString().slice(0, 10),
  }),
  watch: {
    // std() {
    //   this.getDivOff();
    // },
    // current_academic_year() {
    //   this.getDivOff();
    // },
    // division() {
    //   this.get_calendar();
    // },
    // edit_dialog(val) {
    //   val || this.close();
    // }
  },
  methods: {
     fetchNotices(){
                this.init_loader = true;
                const formData = {
                    comm_type: "Calendar",
                    for: "all",
                    fromdate:this.fromdate,
                    todate:this.todate,
                    ay:this.academicyear.id
                };
                axios
                    .post("/Communication/getNoticesBetweenDates", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.d_ay = res.data.d_ay;
                            this.from_date = res.data.from_date;
                            this.to_date = res.data.to_date;
                            this.calendar_list = res.data.communication_list;
                            this.cum_list = res.data.cum_list;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.init_loader = false;
                    });
            },
     async deleteCommnByMsgId(key) {
            this.delete_loader = true;
            const formdata ={
                key:key
            }
            try {
                const res = await axios.post("/communication/deleteCommnByMsgId", formdata)
                console.log(res.data.flag)
                if (res.data.flag == "YES") {
                    this.showSnackbar("green", res.data.snackbar);
                    this.get_ay_std()
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.delete_loader = false;
            }
            catch (err) {
                console.log("err", err)
                this.showSnackbar("red", "Something went wrong!!!");
                this.delete_loader = false;
            }
            finally {
                console.log("bye...")
                this.delete_loader = false;
                this.fetchNotices();
            }

        },
       getStatus(id){
       const formData = {
        comm_id:id,
      };
       axios
        .post("/Communication/getcommunicationStatus", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
           this.comm_read_status=res.data.read_list
           this.status_dialog=true
            this.total_receipients=res.data.total_receipients
          }  if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
           this.status_dialog=false
          } 
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
        });
    },
    get_divisions_stream(stream) {
      const formData = {
        ay: this.academicyear.id,
        stream: stream.id,
      };
      axios
        .post("/Communication/get_stream_divisions", formData)
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.division_list = res.data.division_list;
            // this.standard_list=res.data.standard_list;
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {});
    },
    hasWhiteSpace(s) {
      var status = false;
      var reWhiteSpace = new RegExp(/^\s+$/);

      // Check for white space
      if (reWhiteSpace.test(s)) {
        // alert("Please Check Your Fields For Spaces");
        return true;
      }
      return false;
    },
    putCalendar() {
      if (this.hasWhiteSpace(this.title) || this.title == null) {
        this.showSnackbar("#b71c1c", "Please Enter Title");
        return;
      }
      

      if (this.datetime == null) {
        this.showSnackbar("#b71c1c", "Please select Date and Time!!!"); // show snackbar
        this.send_btn_load = false;
      }
      if (this.event_type == null || this.event_type == "") {
        this.showSnackbar("#b71c1c", "Please select Event Type!!!"); // show snackbar
        this.send_btn_load = false;
      } else {
        this.send_btn_load = true;
        let formData = new FormData();
        for (var i = 0; i < this.division.length; i++) {
        let division = this.division[i].id;
        formData.append("div", division);
      }
        formData.append("ay", this.academicyear.id);
        // formData.append("std", this.standard.id);
        formData.append("stream", this.stream.id);
       // formData.append("div", this.division.id);
        formData.append("title", this.title);
        formData.append("description", this.description);
        formData.append("type", "Calendar");
        formData.append("event", this.event_type);
        formData.append("eventdate", this.datetime);
        //formData.append("eventdate", this.formatDate(this.datetime, true));
        axios
          .post("/Communication/putNoticeHWAlbum", formData, {})
          .then((res) => {
            if (res.data.msg == "200") {
              if (res.data.status == "SUCCESS") {
                // alert("Success");
                this.showSnackbar(
                  "#4caf50",
                  "Calendar event added successfully..."
                ); // show snackbar on success
              } else {
                this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
                //alert(res.data.status_reason);
              }
              //this.get_calendar();
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            //close loader
            this.title=null,
            this.description="",
            this.event_type="",
            this.datetime=null,
            this.send_btn_load = false;
            this.get_ay_std();
            this.fetchNotices();
          });
      }
    },
    get_ay_std() { 
      const formData = {
        comm_type: "Calendar",
        for: "all",
      };
      axios
        .post("/Communication/gerInitialData", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            //this.calendar_list = res.data.communication_list;
            (this.ay_list = res.data.ay_list),
              (this.academicyear = res.data.current_ay);
            this.stream_list = res.data.stream_list_all;
            this.event_type_list = res.data.event_type_list;
            //this.cum_list = res.data.cum_list;
            // this.from_date = res.data.from_date;
            // this.to_date = res.data.to_date;
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.first_load = true;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    deleteCalendarEvent(item) {
      this.delete_attach_load = true;
      //alert(item.id)
      if (!confirm("Are you sure you want to delete this calendar event?"))
        return;
      const formData = {
        comm_id: item.id,
      };
      axios
        .post("/communicationType/deleteCommunication", formData)
        .then((res) => {
          if (res.data.status == "YES") {
            this.showSnackbar("#4caf50", res.data.status_reason); // show snackbar on success
            //alert(res.data.status_reason)
            const index = this.event_type.indexOf(item);
            this.get_ay_std();
            //this.event_type.splice(index, 1);
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
            //alert(res.data.status_reason)
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.delete_attach_load = false;
          this.fetchNotices();
        });
    },
  },
  mounted() {
    this.get_ay_std();
    this.view = "Single";
    this.basepath = localStorage.getItem("awspath");
  },
};
</script>
<style scoped>
.allot-btn,
.allot-icon,
.info-icon {
  transition: 0.3s;
}
.allot-btn:hover .allot-icon {
  color: white;
}
.allot-btn:hover {
  background-color: #193a9a !important;
  border-color: #193a9a !important;
  color: white;
}

.info-icon:hover {
  background-color: #193a9a !important;
  border-color: #193a9a !important;
  color: white;
  border-radius: 100%;
}
.table-sub-title {
  margin-left: 1%;
  font-weight: 500;
  color: #999;
}
@media print {
  body {
    height: 100%;
    width: 100%;
  }
  .no-display {
    display: none !important;
  }
  .v-data-footer,
  .v-data-footer__select,
  .v-data-footer__pagination {
    display: none !important;
    visibility: hidden !important;
  }
  .v-data-table table,
  .v-data-table__wrapper {
    width: 100% !important;
    display: block !important;
  }

  table,
  th,
  td {
    border-collapse: collapse !important;
    border: 1px solid black !important;
    width: 100%;
    text-align: right !important;
  }
}
</style>
